module.exports = __webpack_public_path__ + "img/public/SiteIcons/importIcon.svg?50bdbbff";